import { Flex, SystemProps, Text, LegacyText } from "flicket-ui";
import styled from "styled-components";
import { Select } from "~components";
import { SeatsIOSeat } from "~components/reservation/constants";
import { formatSeatLocation } from "~lib";
import PriceWithFee from "../../common/common.PriceWithFee";
import { ListItemDetails } from "./PricingListItemDetails";
import { StylesConfig } from "react-select";

const StyledListItem = styled(Flex)<SystemProps>`
  margin-bottom: ${(p) => p.theme.space[3]}px;

  justify-content: space-between;
  align-items: start;
`;

interface ListItemProps {
  seat: SeatsIOSeat;
  options: any[];
  handleTicketTypeChange: (id: any, newType: any) => void;
  showHiddenFees?: boolean;
}

export const ListItem = ({
  seat,
  options,
  handleTicketTypeChange,
  showHiddenFees = false,
}: ListItemProps) => {
  const hasTicketsAvailable = options?.length > 0;

  return (
    <StyledListItem mb={{ _: "5/4", md: 3 }} key={seat?.uuid}>
      <Flex flexDir="column" mr={1}>
        <LegacyText fontSize={3} lineHeight="normal" fontWeight="heavy" color="N800">
          {/* don't pass zone label to avoid duplication */}
          {formatSeatLocation(
            undefined,
            seat.sectionLabel,
            seat.label,
            seat.objectType
          )}
        </LegacyText>
        {hasTicketsAvailable && (
          <>
            <LegacyText fontSize={2} lineHeight="normal" color="N600" mt="1/2">
              <PriceWithFee
                price={seat.originalPrice}
                ticketType={seat.ticketType}
                showFees={showHiddenFees}
              />
            </LegacyText>
            <ListItemDetails
              name={seat?.ticketType?.label}
              description={seat?.ticketType?.description}
              restrictions={seat?.ticketType?.restrictions}
              addonImage={seat?.ticketType?.addonImage}
              ticketImage={seat?.ticketType?.ticketImage}
              ticketType={seat}
            />
          </>
        )}
      </Flex>
      <Flex minW="128px">
        {(() => {
          if (!hasTicketsAvailable) {
            return (
              <LegacyText
                fontSize={2}
                textAlign="end"
                lineHeight="normal"
                color="N600"
                mt="1/2"
              >
                No tickets available
              </LegacyText>
            );
          }

          const defaultOption =
            options.find((option) => option.value === seat?.ticketType?.id) ||
            options[0];

          return (
            <Select
              options={options}
              onChange={(value) =>
                handleTicketTypeChange(seat?.customId ?? seat.id, value)
              }
              defaultValue={{
                label: defaultOption.label,
                value: defaultOption.value,
              }}
              small
              selectProps={{
                isSearchable: false,
                // Menu should be:
                // - At least as wide as the input
                // - No wider than the container/viewport
                // - Right-aligned with the input
                // - As wide as the widest option, within the constraints above
                styles: {
                  menu: (provided) => ({
                    ...provided,
                    width: "max-content",
                    position: "absolute",
                    right: 0,
                    maxWidth: "325px",
                    minWidth: "100%",
                  }),
                  menuList: (provided) => ({
                    ...provided,
                    width: "max-content",
                    maxWidth: "325px",
                    minWidth: "100%",
                  }),
                } as StylesConfig,
              }}
            />
          );
        })()}
      </Flex>
    </StyledListItem>
  );
};
